export const WEBAPP_BANKSLIST_CLICKEDOPENCASHAVAILABLEMODAL =
  'WEBAPP_BANKSLIST_CLICKEDOPENCASHAVAILABLEMODAL';
export const WEBAPP_BANKSLIST_CLICKEDCLOSECASHAVAILABLEMODAL =
  'WEBAPP_BANKSLIST_CLICKEDCLOSECASHAVAILABLEMODAL';
export const WEBAPP_BANKSLIST_CHANGEDCASHAVAILABLEFACTOR =
  'WEBAPP_BANKSLIST_CHANGEDCASHAVAILABLEFACTOR';
export const WEBAPP_BANKSLIST_CHANGEDFILTERS =
  'WEBAPP_BANKSLIST_CHANGEDFILTERS';
export const WEBAPP_BANKSLIST_CLICKEDTOGGLEFILTERS =
  'WEBAPP_BANKSLIST_CLICKEDTOGGLEFILTERS';
export const WEBAPP_BANKSLIST_CHANGEDPAGE = 'WEBAPP_BANKSLIST_CHANGEDPAGE';
export const WEBAPP_BANKSLIST_CLICKEDLOADMORETRANSACTIONS =
  'WEBAPP_BANKSLIST_CLICKEDLOADMORETRANSACTIONS';
export const WEBAPP_BANKSLIST_SORTEDLIST = 'WEBAPP_BANKSLIST_SORTEDLIST';
export const WEBAPP_BANKSLIST_SWITCHEDTOBANKACCOUNTTAB =
  'WEBAPP_BANKSLIST_SWITCHEDTOBANKACCOUNTTAB';
export const WEBAPP_BANKSLIST_CLICKEDTRANSACTION =
  'WEBAPP_BANKSLIST_CLICKEDTRANSACTION';
export const WEBAPP_BANKSLIST_CLICKEDCLOSETRANSACTION =
  'WEBAPP_BANKSLIST_CLICKEDCLOSETRANSACTION';
export const WEBAPP_BANKSLIST_CLICKEDCLASSIFYASNEWEXPENSE =
  'WEBAPP_BANKSLIST_CLICKEDCLASSIFYASNEWEXPENSE';
export const WEBAPP_BANKSLIST_CLICKEDLINKTOEXPENSES =
  'WEBAPP_BANKSLIST_CLICKEDLINKTOEXPENSES';
export const WEBAPP_BANKSLIST_CLICKLINKTOREVENUES =
  'WEBAPP_BANKSLIST_CLICKLINKTOREVENUES';
export const WEBAPP_BANKSLIST_CLICKEDMARKASPERSONAL =
  'WEBAPP_BANKSLIST_CLICKEDMARKASPERSONAL';
export const WEBAPP_BANKSLIST_TOGGLEDCLASSIFYASREVENUESDROPDOWN =
  'WEBAPP_BANKSLIST_TOGGLEDCLASSIFYASREVENUESDROPDOWN';
export const WEBAPP_BANKSLIST_CLICKEDCLASSIFYASNEWSALESINVOICE =
  'WEBAPP_BANKSLIST_CLICKEDCLASSIFYASNEWSALESINVOICE';
export const WEBAPP_BANKSLIST_CLICKEDCLASSIFYASOTHERREVENUE =
  'WEBAPP_BANKSLIST_CLICKEDCLASSIFYASOTHERREVENUE';
export const WEBAPP_BANKSLIST_CLICKEDLINKTOCREDITNOTEONPURCHASE =
  'WEBAPP_BANKSLIST_CLICKEDLINKTOCREDITNOTEONPURCHASE';
export const WEBAPP_BANKSLIST_CLICKEDLINKTOCREDITNOTEONSALE =
  'WEBAPP_BANKSLIST_CLICKEDLINKTOCREDITNOTEONSALE';
export const WEBAPP_BANKSLIST_CLICKEDOPENCLASSIFICATIONPICKER =
  'WEBAPP_BANKSLIST_CLICKEDOPENCLASSIFICATIONPICKER';
export const WEBAPP_BANKSLIST_UPDATEDCLASSIFICATIONCATEGORY =
  'WEBAPP_BANKSLIST_UPDATEDCLASSIFICATIONCATEGORY';
export const WEBAPP_BANKSLIST_CLICKEDVIEWLINKEDEXPENSEDETAILS =
  'WEBAPP_BANKSLIST_CLICKEDVIEWLINKEDEXPENSEDETAILS';
export const WEBAPP_BANKSLIST_CLICKEDVIEWLINKEDREVENUEDETAILS =
  'WEBAPP_BANKSLIST_CLICKEDVIEWLINKEDREVENUEDETAILS';
export const WEBAPP_BANKSLIST_CLICKEDSAVETOSUBMITCLASSIFICATION =
  'WEBAPP_BANKSLIST_CLICKEDSAVETOSUBMITCLASSIFICATION';
export const WEBAPP_BANKSLIST_CLICKEDCANCELLINKINGMODAL =
  'WEBAPP_BANKSLIST_CLICKEDCANCELLINKINGMODAL';
export const WEBAPP_BANKSLIST_CLICKEDSAVETOSUBMITLINKING =
  'WEBAPP_BANKSLIST_CLICKEDSAVETOSUBMITLINKING';
export const WEBAPP_BANKSLIST_CLICKEDCONNECTBANKACCOUNT =
  'WEBAPP_BANKSLIST_CLICKEDCONNECTBANKACCOUNT';
export const WEBAPP_BANKSLIST_ONBOARDINGCONNECTBANKACCOUNT =
  'WEBAPP_BANKSLIST_ONBOARDINGCONNECTBANKACCOUNT';
export const WEBAPP_BANKSLIST_IBANITYMODAL_SELECTEDBANK =
  'WEBAPP_BANKSLIST_IBANITYMODAL_SELECTEDBANK';
export const WEBAPP_BANKSLIST_IBANITYMODAL_CLICKEDSELECTYOURBANKSTEP =
  'WEBAPP_BANKSLIST_IBANITYMODAL_CLICKEDSELECTYOURBANKSTEP';
export const WEBAPP_BANKSLIST_IBANITYMODAL_CLICKEDIBANINPUT =
  'WEBAPP_BANKSLIST_IBANITYMODAL_CLICKEDIBANINPUT';
export const WEBAPP_BANKSLIST_IBANITYMODAL_CLICKEDUSERNAMEINPUT =
  'WEBAPP_BANKSLIST_IBANITYMODAL_CLICKEDUSERNAMEINPUT';
export const WEBAPP_BANKSLIST_IBANITYMODAL_CLICKEDSUBMIT =
  'WEBAPP_BANKSLIST_IBANITYMODAL_CLICKEDSUBMIT';
export const WEBAPP_BANKSLIST_TINKMODAL_SELECTEDBANK =
  'WEBAPP_BANKSLIST_TINKMODAL_SELECTEDBANK';
export const WEBAPP_BANKSLIST_TINKMODAL_CLICKEDSELECTYOURBANKSTEP =
  'WEBAPP_BANKSLIST_TINKMODAL_CLICKEDSELECTYOURBANKSTEP';
export const WEBAPP_BANKSLIST_TINKMODAL_CLICKEDIBANINPUT =
  'WEBAPP_BANKSLIST_TINKMODAL_CLICKEDIBANINPUT';
export const WEBAPP_BANKSLIST_TINKMODAL_CLICKEDSUBMIT =
  'WEBAPP_BANKSLIST_TINKMODAL_CLICKEDSUBMIT';
export const WEBAPP_BANKSLIST_ONECLICKCLASSIFICATION_VIEWEDTOOLTIP =
  'WEBAPP_BANKSLIST_ONECLICKCLASSIFICATION_VIEWEDTOOLTIP';
export const WEBAPP_BANKSLIST_ONECLICKCLASSIFICATION_CLICKEDEDIT =
  'WEBAPP_BANKSLIST_ONECLICKCLASSIFICATION_CLICKEDEDIT';
export const WEBAPP_BANKSLIST_ONECLICKCLASSIFICATION_CLICKEDCONFIRM =
  'WEBAPP_BANKSLIST_ONECLICKCLASSIFICATION_CLICKEDCONFIRM';
export const WEBAPP_BANKSLIST_ONECLICKCLASSIFICATION_CLICKEDCONTINUE =
  'WEBAPP_BANKSLIST_ONECLICKCLASSIFICATION_CLICKEDCONTINUE';
export const WEBAPP_BANKING_STATUS_INVALIDIDENTIFICATION_CLICKTRYAGAIN =
  'WEBAPP_BANKING_STATUS_INVALIDIDENTIFICATION_CLICKTRYAGAIN';
export const WEBAPP_BANKING_STATUS_AUTHORIZATIONFAILED_CLICKEDFINALIZEDVERIFICATION =
  'WEBAPP_BANKING_STATUS_AUTHORIZATIONFAILED_CLICKEDFINALIZEDVERIFICATION';
export const WEBAPP_BANKING_VIEWEDMAINACCOUNT =
  'WEBAPP_BANKING_VIEWEDMAINACCOUNT';
export const WEBAPP_BANKING_VIEWEDTAXRESERVEACCOUNT =
  'WEBAPP_BANKING_VIEWEDTAXRESERVEACCOUNT';
export const WEBAPP_BANKING_VIEWEDSUBACCOUNT =
  'WEBAPP_BANKING_VIEWEDSUBACCOUNT';
export const WEBAPP_BANKING_NUDGES_CLICKEDTOPUPTAXRESERVE =
  'WEBAPP_BANKING_NUDGES_CLICKEDTOPUPTAXRESERVE';
export const WEBAPP_BANKING_ONBOARDING_OURPROMISES_CLICKNEXT =
  'WEBAPP_BANKING_ONBOARDING_OURPROMISES_CLICKNEXT';
export const WEBAPP_BANKING_ONBOARDING_IDENTITYCONFIRMATION_CLICKCONFIRM =
  'WEBAPP_BANKING_ONBOARDING_IDENTITYCONFIRMATION_CLICKCONFIRM';
export const WEBAPP_BANKING_ONBOARDING_DISMISSEDSETASIDEBANNER =
  'WEBAPP_BANKING_ONBOARDING_DISMISSEDSETASIDEBANNER';
export const WEBAPP_BANKING_ACTIVATECARDBANNER_CLICKEDACTIVATECARD =
  'WEBAPP_BANKING_ACTIVATECARDBANNER_CLICKEDACTIVATECARD';
export const WEBAPP_BANKING_ACTIVATECARDBANNER_DISMISSEDBANNER =
  'WEBAPP_BANKING_ACTIVATECARDBANNER_DISMISSEDBANNER';
export const WEBAPP_BANKING_ADDIBANTOINVOICEBANNER_CLICKEDACTIVATECARD =
  'WEBAPP_BANKING_ADDIBANTOINVOICEBANNER_CLICKEDACTIVATECARD';
export const WEBAPP_BANKING_ADDIBANTOINVOICEBANNER_DISMISSEDBANNER =
  'WEBAPP_BANKING_ADDIBANTOINVOICEBANNER_DISMISSEDBANNER';
export const WEBAPP_BANKING_BANKLIST_CLICKEDSETASIDE =
  'WEBAPP_BANKING_BANKLIST_CLICKEDSETASIDE';
export const WEBAPP_BANKING_BANKLIST_CLICKEDADDMONEY =
  'WEBAPP_BANKING_BANKLIST_CLICKEDADDMONEY';
export const WEBAPP_BANKING_CASHAVAILBLE_CLICKEDSETASIDE =
  'WEBAPP_BANKING_CASHAVAILBLE_CLICKEDSETASIDE';
export const WEBAPP_BANKING_NUDGES_CLICKEDSETASIDE =
  'WEBAPP_BANKING_NUDGES_CLICKEDSETASIDE';
export const WEBAPP_BANKING_BANKLIST_SETASIDEBANNER_CLICKEDSETASIDE =
  'WEBAPP_BANKING_BANKLIST_SETASIDEBANNER_CLICKEDSETASIDE';
export const WEBAPP_BANKING_TAXES_CLICKEDPAYWITHACCOUNTABLE =
  'WEBAPP_BANKING_TAXES_CLICKEDPAYWITHACCOUNTABLE';
export const WEBAPP_BANKING_PAYMENTTRANSFER_VIEWEDSOURCEACCOUNTSELECTION =
  'WEBAPP_BANKING_PAYMENTTRANSFER_VIEWEDSOURCEACCOUNTSELECTION';
export const WEBAPP_BANKING_PAYMENTTRANSFER_VIEWEDRECIPIENTACCOUNTSELECTION =
  'WEBAPP_BANKING_PAYMENTTRANSFER_VIEWEDRECIPIENTACCOUNTSELECTION';
export const WEBAPP_BANKING_PAYMENTTRANSFER_VIEWEDTRANSFERFORM =
  'WEBAPP_BANKING_PAYMENTTRANSFER_VIEWEDTRANSFERFORM';
export const WEBAPP_BANKING_PAYMENTTRANSFER_INTERNALTRANSFER_VIEWEDAMOUNTFORM =
  'WEBAPP_BANKING_PAYMENTTRANSFER_INTERNALTRANSFER_VIEWEDAMOUNTFORM';
export const WEBAPP_BANKING_PAYMENTTRANSFER_INTERNALTRANSFER_VIEWEDREVIEWTRANSFER =
  'WEBAPP_BANKING_PAYMENTTRANSFER_INTERNALTRANSFER_VIEWEDREVIEWTRANSFER';
export const WEBAPP_BANKING_PAYMENTTRANSFER_INTERNALTRANSFER_CLICKEDCONFIRMTRANSFER =
  'WEBAPP_BANKING_PAYMENTTRANSFER_INTERNALTRANSFER_CLICKEDCONFIRMTRANSFER';
export const WEBAPP_BANKING_PAYMENTTRANSFER_INTERNALTRANSFER_CLICKEDCANCEL =
  'WEBAPP_BANKING_PAYMENTTRANSFER_INTERNALTRANSFER_CLICKEDCANCEL';
export const WEBAPP_BANKING_PAYMENTTRANSFER_EXTERNALTRANSFER_VIEWEDRECIPIENTINFOFORM =
  'WEBAPP_BANKING_PAYMENTTRANSFER_EXTERNALTRANSFER_VIEWEDRECIPIENTINFOFORM';
export const WEBAPP_BANKING_PAYMENTTRANSFER_EXTERNALTRANSFER_VIEWEDREVIEWTRANSFER =
  'WEBAPP_BANKING_PAYMENTTRANSFER_EXTERNALTRANSFER_VIEWEDREVIEWTRANSFER';
export const WEBAPP_BANKING_PAYMENTTRANSFER_EXTERNALTRANSFER_CLICKEDCONFIRMTRANSFER =
  'WEBAPP_BANKING_PAYMENTTRANSFER_EXTERNALTRANSFER_CLICKEDCONFIRMTRANSFER';
export const WEBAPP_BANKING_PAYMENTTRANSFER_EXTERNALTRANSFER_CLICKEDCANCEL =
  'WEBAPP_BANKING_PAYMENTTRANSFER_EXTERNALTRANSFER_CLICKEDCANCEL';
export const WEBAPP_BANKING_PAYMENTTRANSFER_SUCCESSFULTRANSFER =
  'WEBAPP_BANKING_PAYMENTTRANSFER_SUCCESSFULTRANSFER';
export const WEBAPP_BANKING_IBANBANNER_CLICKEDADDIBAN =
  'WEBAPP_BANKING_IBANBANNER_CLICKEDADDIBAN';
export const WEBAPP_BANKING_BANKLIST_SCHEDULEDPAYMENTS_CLICKEDSCHEDULEPAYMENTBUTTON =
  'WEBAPP_BANKING_BANKLIST_SCHEDULEDPAYMENTS_CLICKEDSCHEDULEPAYMENTBUTTON';
export const WEBAPP_BANKING_BANKLIST_SCHEDULEDPAYMENTS_CLICKEDDELETE =
  'WEBAPP_BANKING_BANKLIST_SCHEDULEDPAYMENTS_CLICKEDDELETE';
export const WEBAPP_BANKING_BANKLIST_SCHEDULEDPAYMENTS_DISMISSEDSLIDEOVER =
  'WEBAPP_BANKING_BANKLIST_SCHEDULEDPAYMENTS_DISMISSEDSLIDEOVER';
export const WEBAPP_BANKING_BANKLIST_CLICKEDSCHEDULEDPAYMENTSMENUITEM =
  'WEBAPP_BANKING_BANKLIST_CLICKEDSCHEDULEDPAYMENTSMENUITEM';
export const WEBAPP_BANKING_BANKLIST_SCHEDULEDPAYMENTS_CLICKEDSELECTPAYMENTSCHEDULE =
  'WEBAPP_BANKING_BANKLIST_SCHEDULEDPAYMENTS_CLICKEDSELECTPAYMENTSCHEDULE';
export const WEBAPP_BANKING_BANKLIST_REVIEWSCHEDULEDPAYMENTS_CLICKEDEDITSCHEDULE =
  'WEBAPP_BANKING_BANKLIST_REVIEWSCHEDULEDPAYMENTS_CLICKEDEDITSCHEDULE';
export const WEBAPP_BANKING_ONBOARDING_VISITEDMEETACCOUNTABLEBAKINGSCREEN =
  'WEBAPP_BANKING_ONBOARDING_VISITEDMEETACCOUNTABLEBAKINGSCREEN';
export const WEBAPP_BANKING_ONBOARDING_VISITEDINVOICESBONUSSCREEN =
  'WEBAPP_BANKING_ONBOARDING_VISITEDINVOICESBONUSSCREEN';
export const WEBAPP_BANKING_ONBOARDING_VISITEDFEESLISTSCREEN =
  'WEBAPP_BANKING_ONBOARDING_VISITEDFEESLISTSCREEN';
export const WEBAPP_BANKING_ONBOARDING_VISITEDAUTOMATETAXESSCREEN =
  'WEBAPP_BANKING_ONBOARDING_VISITEDAUTOMATETAXESSCREEN';
export const WEBAPP_BANKING_ONBOARDING_VISITEOURPROMISESSCREEN =
  'WEBAPP_BANKING_ONBOARDING_VISITEOURPROMISESSCREEN';
export const WEBAPP_BANKING_ONBOARDING_VISITEPERSONALDETAILSFORMSCREEN =
  'WEBAPP_BANKING_ONBOARDING_VISITEPERSONALDETAILSFORMSCREEN';
export const WEBAPP_BANKING_ONBOARDING_VISITEPROOFOFREGISTRATIONSCREEN =
  'WEBAPP_BANKING_ONBOARDING_VISITEPROOFOFREGISTRATIONSCREEN';
export const WEBAPP_BANKING_ONBOARDING_VISITEPANALYSINGDOCSSCREEN =
  'WEBAPP_BANKING_ONBOARDING_VISITEPANALYSINGDOCSSCREEN';
export const WEBAPP_BANKING_ONBOARDING_VISITEPIDENTITYCONFIRMATIONSCREEN =
  'WEBAPP_BANKING_ONBOARDING_VISITEPIDENTITYCONFIRMATIONSCREEN';
export const WEBAPP_BANKING_ONBOARDING_AIDOCSCANNING_CLICKEDCONTACTCOACHES =
  'WEBAPP_BANKING_ONBOARDING_AIDOCSCANNING_CLICKEDCONTACTCOACHES';
export const WEBAPP_BANKING_ONBOARDING_AIDOCSCANNING_CLICKEDTRYANOTHERDOC =
  'WEBAPP_BANKING_ONBOARDING_AIDOCSCANNING_CLICKEDTRYANOTHERDOC';
export const WEBAPP_BANKING_ONBOARDING_AIDOCSCANNING_CLICKEDCONFIRMDOCISCORRECT =
  'WEBAPP_BANKING_ONBOARDING_AIDOCSCANNING_CLICKEDCONFIRMDOCISCORRECT';
export const WEBAPP_BANKING_ONBOARDING_AIDOCSCANNING_SUCCESS_CLICKEDNEXT =
  'WEBAPP_BANKING_ONBOARDING_AIDOCSCANNING_SUCCESS_CLICKEDNEXT';

// Subaccount events START
export const WEBAPP_BANKING_SUBACCOUNTS_CLICKEDADD =
  'WEBAPP_BANKING_SUBACCOUNTS_CLICKEDADD';
export const WEBAPP_BANKING_SUBACCOUNTS_VIEWING_PAYWALL =
  'WEBAPP_BANKING_SUBACCOUNTS_VIEWING_PAYWALL';
export const WEBAPP_BANKING_SUBACCOUNTS_VIEWING_ONBOARDING =
  'WEBAPP_BANKING_SUBACCOUNTS_VIEWING_ONBOARDING';

export const WEBAPP_BANKING_SUBACCOUNTS_CREATING_SETNAME =
  'WEBAPP_BANKING_SUBACCOUNTS_CREATING_SETNAME';
export const WEBAPP_BANKING_SUBACCOUNTS_CREATING_SETICON =
  'WEBAPP_BANKING_SUBACCOUNTS_CREATING_SETICON';
export const WEBAPP_BANKING_SUBACCOUNTS_CREATING_SETGOAL =
  'WEBAPP_BANKING_SUBACCOUNTS_CREATING_SETGOAL';
export const WEBAPP_BANKING_SUBACCOUNTS_CREATING_SKIPGOAL =
  'WEBAPP_BANKING_SUBACCOUNTS_CREATING_SKIPGOAL';
export const WEBAPP_BANKING_SUBACCOUNTS_EDITING_NAME =
  'WEBAPP_BANKING_SUBACCOUNTS_EDITING_NAME';
export const WEBAPP_BANKING_SUBACCOUNTS_EDITING_ICON =
  'WEBAPP_BANKING_SUBACCOUNTS_EDITING_ICON';
export const WEBAPP_BANKING_SUBACCOUNTS_EDITING_GOAL =
  'WEBAPP_BANKING_SUBACCOUNTS_EDITING_GOAL';
// Subaccount events END
